import React, { useEffect, useState } from "react";
import "./My_rewards.css";
import { Tab, Nav, Table } from "react-bootstrap";

import Rewards from "./rewards/Rewards";
import CoinsTransactions from "./coinsTransactions/CoinsTransactions";
import Settings from "./settings/Settings";
import {
  UserGet,
  UserWalletHistory,
} from "../../../utils/apis/myAccount/myAccount";
import { PointSetup } from "../../../utils/apis/master/Master";

function My_rewards() {
  const [user, setUser] = useState();
  const getUserData = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUser(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [WalletHistory, setWalletHistory] = useState();
  const getUserWalletHistory = async () => {
    const res = await UserWalletHistory();
    if (res?.success) {
      setWalletHistory(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [pointSetup, setPointSetup] = useState();
  const getPointsetup = async () => {
    const res = await PointSetup();
    if (res?.success) {
      setPointSetup(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getPointsetup();
    getUserData();
    getUserWalletHistory();
  }, []);
  return (
    <>
      <section className="My_rewards">
        <div className="My_rewards_main">
          <Tab.Container defaultActiveKey="myRewards">
            {/* Tabs */}
            <div className="custom_container">
              <div className="My_rewards_tabs_wrapper">
                <Nav variant="tabs" className="My_rewards_tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="myRewards" className="My_rewards_tab">
                      My Rewards
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      eventKey="coinsTransactions"
                      className="My_rewards_tab"
                    >
                      Coins Transactions
                    </Nav.Link>
                  </Nav.Item>

                  {/* <Nav.Item>
                    <Nav.Link eventKey="settings" className="My_rewards_tab">
                      Settings
                    </Nav.Link>
                  </Nav.Item> */}
                </Nav>
              </div>
            </div>

            {/* Tab Content */}
            <Tab.Content>
              {/* ================= My Rewards ================= */}
              <Tab.Pane eventKey="myRewards">
                <div className="custom_container">
                  <Rewards
                    WalletHistory={WalletHistory}
                    pointSetup={pointSetup}
                    user={user}
                  />
                </div>
              </Tab.Pane>

              {/* ================= Coins Transactions ================= */}
              <Tab.Pane eventKey="coinsTransactions">
                <div className="custom_container">
                  <CoinsTransactions
                    WalletHistory={WalletHistory}
                    pointSetup={pointSetup}
                    user={user}
                  />
                </div>
              </Tab.Pane>

              {/* ================= Settings ================= */}
              <Tab.Pane eventKey="settings">
                <div className="custom_container">
                  <Settings />
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
    </>
  );
}

export default My_rewards;
